<template>
  <div>
    <EncodeHeader base64Decode/>
    <v-container>
      <v-row>
        <v-col cols="8">
          <v-textarea
            outlined
            name="input-10-6"
            label="Encoded Text"
            rows='8'
            v-model="encodedText"
          ></v-textarea>
          <v-btn block color="primary" dark @click="handleDecode()">Decode</v-btn>
          <br/>
          <v-textarea
            outlined
            name="input-10-6"
            label="Plain Text"
            rows='8'
            v-model="text"
          ></v-textarea>          
        </v-col>
        <v-col cols="4">
          <!-- <img src="https://static.wikia.nocookie.net/kungfupanda/images/7/73/KFP3-promo-po4.jpg"> -->
          <p>Did you know?</p>
          <ul>
            <li>Base64 is not an encryption!</li>
            <li>Base64 is just a binary to text encoding!</li>
            <li>Base64 can be used for image encoding and URL encoding</li>
            <li>Base64 encoded data can be transferred over media that are designed to deal with ASCII</li>
            <li>Base64 encoded can also be decoded to plain ASCII text</li>
            <li>Base64 also has URL safe encoding!</li>
            <li>Base64 can also be used for email attachments!</li>
            <li>Base64 encoding happens by converting ascii to binary i.e 8 bits to group of 6 bits!</li>
            <li>Base64 adds <code>=</code> sign for padding!</li>
          </ul>                  
        </v-col>
      </v-row>
    </v-container>    
  </div>
</template>

<script>
export default {
  components: {
    EncodeHeader: () => import('./EncodeHeader.vue')
  },
  data() {
    return {
      text: "",
      encodedText: "",
      // adsenseContent: '',
      name: "Base64 Decode"
    };
  },
  created () {
      document.title = "Online Base64 Decode - Encodify";
  },
  // mounted (){

  //   this.adsenseContent = document.getElementById('adsgoeshere').innerHTML;
  // },
  methods: {
    handleDecode() {
      this.text = atob(this.encodedText);
    }
  }
};
</script>
